import {
    REGISTER_NEXT_STEP,
    REGISTER_SET_STEP,
    REGISTER_PREV_STEP,
    REGISTER_PROCESS,
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    REGISTERFORM_UPDATE,
    UPDATE_COUNTRIESLIST,
    UPDATE_HEALTHCONDITION,
    UPDATE_CLINIC,
    UPDATE_PROMOCODEDATA,
    REGISTER_GOTO_STEP,
    ASSIGN_FACEBOOK_VALUES,
    ASSIGN_GOOGLE_VALUES,
    UPDATE_CONDITION_RELATION,
    UPDATE_MEMBERSHIP_PLANS,
    INNER_REGISTER_NEXT_STEP,
    INNER_REGISTER_PREV_STEP,
    PACKSTER_GOTO_REGISTER,
    RESET_REGISTER,
    UPDATE_HEARABOUT,
    UPDATE_WARNING_BANNER,
    REGISTER_GET_INSTRUCTOR,
    REGISTER_SET_CONDITION_INDEX,
    UPDATE_LICENSE_LIST,
    UPDATE_COUNTRY_PLANS,
    CLEAR_REGISTERFORM,
    CHECK_CONDITION_CODE,
    SET_LOADING,
    SET_PAGE_TITLE,
    SET_NEW_USER,
    SET_MASTER_USER_ID,
    SET_ALL_USER_LIST,
    SET_SIGN_UP_USER_LIST,
    USER_IP_BASED_COUNTRY_DETAILS,
    GET_PAGE_DATA, 
} from '../utilities';
let _ = require('lodash');

const INITIAL_STATE = {
    sending_data: false,
    is_auth: false,
    user_data: {},
    step: -1,
    condition_index: 0,
    clinic_direction: 'forward',
    countries_list: [],
    healthcondition_list: [],
    warning_banner_text: [],
    heard_from: [],
    clinic_list: [],
    promo_plans: [],
    conditionRelationshipList: [],
    registerFormValues: { ispackster: false, userid: 0, terms: false, firstname: '', lastname: '', username: '', email: '', password: '', confirm_password: '', gender: '', profession: '', midicalcondition_livewith: '', country: '', postcode: '', health_condition: [], region: '', clinic_status: '', conditional_clinic: [], healthcondition_livewith: '', purpose: '', is_newfeature_updates: false, is_research_opportunities: false, dob_day: '', dob_month: '', dob_year: '', know_via: '', promocode: '', card_name: '', card_number: '', card_exp_year: '', card_exp_month: '', card_security_code: '', card_zipcode: '', membershipPlan: {}, facebookAccessToken: '', facebookId: '', facebookPicture: '', googleId: '', googlePicture: '', age: 0, usUser: false, krUser: false, shareKRUK: false, emailKRUK: false, ethnicity: '', comorbidities: [], kidney_care_provider: [], is_clinic_found: false, referee: '', beamchallenging: '', condition_professions: [], cancer_treatment: [], cancer_comordities: [], research: false, research_groupname: '', research_condition: '', research_share: '', isKBResearcheUser: false, condition_membership: [], eligible_license: {}, tagCode: {}, movement_prefs: [], cf_comordities: [], cf_disease_severity: [], masterUserID: null, tagCodeList: {}, tagKDYCode: {}, KDYComorbidities: [], cfy_comordities: []  },
    membershipPlan: [],
    instructorList: [],
    licenseList: [],
    countryPlans: {},
    isConditionHasCode: false,
    isLoading: false,
    page_title: "Choose your membership plan",
    is_new_user: false,
    master_user_id: false,
    set_all_user_list: [],
    set_signup_user_list: [],
    user_ip_based_country_details: {},
    page_data : {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_REGISTER:
            console.log('RESET_REGISTER.registerFormValues')

            var registerFormValues = { ispackster: false, userid: 0, terms: false, firstname: '', lastname: '', username: '', email: '', password: '', confirm_password: '', gender: '', profession: '', midicalcondition_livewith: '', country: '', postcode: '', health_condition: [], region: '', clinic_status: '', conditional_clinic: [], healthcondition_livewith: '', purpose: '', is_newfeature_updates: false, is_research_opportunities: false, dob_day: '', dob_month: '', dob_year: '', know_via: '', promocode: '', card_name: '', card_number: '', card_exp_year: '', card_exp_month: '', card_security_code: '', card_zipcode: '', membershipPlan: {}, facebookAccessToken: '', facebookId: '', facebookPicture: '', age: 0, usUser: false, krUser: false, shareKRUK: false, emailKRUK: false, ethnicity: '', comorbidities: [], kidney_care_provider: [], is_clinic_found: false, referee: '', beamchallenging: '', condition_professions: [], cancer_treatment: [], cancer_comordities: [], research: false, research_groupname: '', research_condition: '', research_share: '', isKBResearcheUser: false, condition_membership: [], eligible_license: {}, tagCode: {}, movement_prefs: [], cf_comordities: [], masterUserID: null, parentCountryChecked: false, tagCodeList: {}, tagKDYCode: {}, KDYComorbidities: [], cfy_comordities:[] };
            return {
                ...state,
                step: -1,
                clinic_direction: 'forward',
                registerFormValues: registerFormValues, /* { ispackster: false, userid: 0, terms: false, firstname: '', lastname: '', username: '', email: '', password: '', confirm_password: '', gender: '', profession: '', midicalcondition_livewith: '', country: '', health_condition: [], region: '', clinic_status: '', conditional_clinic: [], healthcondition_livewith: '', purpose: '', is_newfeature_updates: false, is_research_opportunities: false, dob_day: '', dob_month: '', dob_year: '', know_via: '', promocode: '', card_name: '', card_number: '', card_exp_year: '', card_exp_month: '', card_security_code: '', card_zipcode: '', membershipPlan: {}, facebookAccessToken: '', facebookId: '', facebookPicture: '' } */

            };
        case PACKSTER_GOTO_REGISTER:
            var user = action.facebookData;
            var pic = user.picture && user.picture.data && user.picture.data.url ? user.picture.data.url : '';
            var firstname = (user.name) ? user.name : '';
            var username = (user.username) ? user.username : '';
            var email = (user.email) ? user.email : '';
            var facebookAccessToken = (user.accessToken) ? user.accessToken : '';
            var facebookId = (user.id) ? user.id : '';

            var googleUser = action.googleData;
            var pic = googleUser.picture ? googleUser.picture : '';
            var firstname = (googleUser.given_name) ? googleUser.given_name : '';
            var username = (googleUser.username) ? googleUser.username : '';
            var email = (googleUser.email) ? googleUser.email : '';
            var googleId = (googleUser.sub) ? googleUser.sub : '';

            return {
                ...state,
                step: 3,
                clinic_direction: 'forward',
                registerFormValues: { ispackster: true, memberObj: action.memberObj, userid: action.payload, terms: false, firstname: firstname, lastname: '', username: username, email: '', password: '', confirm_password: '', gender: '', profession: '', midicalcondition_livewith: '', country: '', postcode: '', health_condition: [], region: '', clinic_status: '', conditional_clinic: [], healthcondition_livewith: '', purpose: '', is_newfeature_updates: false, is_research_opportunities: false, dob_day: '', dob_month: '', dob_year: '', know_via: '', promocode: '', card_name: '', card_number: '', card_exp_year: '', card_exp_month: '', card_security_code: '', card_zipcode: '', membershipPlan: {}, facebookAccessToken: facebookAccessToken, facebookId: facebookId, facebookPicture: pic, googleId: googleId, googlePicture: pic, parentCountryChecked: false }
            };
        case REGISTER_PROCESS:
            return {
                ...state,
                sending_data: action.payload
            };
        case REGISTER_SUCCESS:
            return {
                ...state,
                user_data: action.payload
            };
        case REGISTER_FAIL:
            return {
                ...state,
                sending_data: false
            };
        case REGISTER_NEXT_STEP:
            return {
                ...state,
                step: state.step + 1,
                //step: (state.step + 1 == 12) ? state.step + 2 : state.step + 1,
                clinic_direction: 'forward'
            };
        case REGISTER_SET_STEP:
            return {
                ...state,
                step: action.payload.step,
                clinic_direction: action.payload.type
            };
        case REGISTER_PREV_STEP:
            return {
                ...state,
                //step: state.step-1,
                step: (state.step - 1 == 12) ? state.step - 2 : state.step - 1,
                clinic_direction: 'backward'
            };
        case INNER_REGISTER_NEXT_STEP:
            return {
                ...state,
                clinic_direction: 'forward'
            };
        case INNER_REGISTER_PREV_STEP:
            return {
                ...state,
                clinic_direction: 'backward'
            };
        case REGISTER_GOTO_STEP:
            return {
                ...state,
                step: action.payload
            };
        case REGISTERFORM_UPDATE:
            return {
                ...state,
                registerFormValues: action.payload
            };
        case UPDATE_COUNTRIESLIST:
            return {
                ...state,
                countries_list: action.payload
            };
        case UPDATE_HEALTHCONDITION:
            let activeConditions = JSON.parse(sessionStorage.getItem('active_conditions'));
            if (activeConditions) {
                let tempActiveConditions = [...activeConditions, ..._.map(action.payload, 'tag')];
                activeConditions = JSON.stringify(_.uniq(tempActiveConditions));
            } else {
                activeConditions = JSON.stringify(_.map(action.payload, 'tag'))
            }
            sessionStorage.setItem('active_conditions', activeConditions)

            return {
                ...state,
                healthcondition_list: action.payload
            };
        case UPDATE_WARNING_BANNER:
            return {
                ...state,
                warning_banner_text: action.payload
            };
        case UPDATE_HEARABOUT:
            return {
                ...state,
                heard_from: action.payload
            };
        case UPDATE_CLINIC:
            let clinic_list = action.payload;
            clinic_list.sort(function (a, b) {
                if (a.clinicName < b.clinicName) { return -1; }
                if (a.clinicName > b.clinicName) { return 1; }
                return 0;
            });
            return {
                ...state,
                clinic_list: clinic_list
            };
        case UPDATE_PROMOCODEDATA:
            return {
                ...state,
                promo_plans: action.payload
            };
        case ASSIGN_FACEBOOK_VALUES:
            var user = action.payload;
            var pic = user.picture && user.picture.data && user.picture.data.url ? user.picture.data.url : '';
            return {
                ...state,
                registerFormValues: { ...state.registerFormValues, firstname: user.first_name, lastname: user.last_name, email: user.email, facebookAccessToken: user.accessToken, facebookId: user.id, facebookPicture: pic }
            };
        case ASSIGN_GOOGLE_VALUES:
            var user = action.payload;
            var pic = user.picture ? user.picture : '';
            return {
                ...state,
                registerFormValues: { ...state.registerFormValues, firstname: user.given_name, lastname: user.family_name, email: user.email, googleId: user.sub, googlePicture: pic }
            };
        case UPDATE_CONDITION_RELATION:
            return {
                ...state,
                conditionRelationshipList: action.payload
            };
        case UPDATE_MEMBERSHIP_PLANS:
            return {
                ...state,
                membershipPlan: action.payload.plans
            };
        case REGISTER_GET_INSTRUCTOR:
            return {
                ...state,
                instructorList: action.payload.instructors
            };
        case REGISTER_SET_CONDITION_INDEX:
            return {
                ...state,
                condition_index: action.payload,
            };
        case UPDATE_LICENSE_LIST:
            return {
                ...state,
                licenseList: action.payload,
            };
        case UPDATE_COUNTRY_PLANS:
            return {
                ...state,
                countryPlans: action.payload,
            };
        case CLEAR_REGISTERFORM:
            console.log('INITIAL_STATE.registerFormValues', INITIAL_STATE)
            var registerFormValues = { ispackster: false, userid: 0, terms: false, firstname: '', lastname: '', username: '', email: '', password: '', confirm_password: '', gender: '', profession: '', midicalcondition_livewith: '', country: '', postcode: '', health_condition: [], region: '', clinic_status: '', conditional_clinic: [], healthcondition_livewith: '', purpose: '', is_newfeature_updates: false, is_research_opportunities: false, dob_day: '', dob_month: '', dob_year: '', know_via: '', promocode: '', card_name: '', card_number: '', card_exp_year: '', card_exp_month: '', card_security_code: '', card_zipcode: '', membershipPlan: {}, facebookAccessToken: '', facebookId: '', facebookPicture: '', age: 0, usUser: false, krUser: false, shareKRUK: false, emailKRUK: false, ethnicity: '', comorbidities: [], kidney_care_provider: [], is_clinic_found: false, referee: '', beamchallenging: '', condition_professions: [], cancer_treatment: [], cancer_comordities: [], research: false, research_groupname: '', research_condition: '', research_share: '', isKBResearcheUser: false, condition_membership: [], eligible_license: {}, tagCode: {}, movement_prefs: [], cf_comordities: [], parentCountryChecked: false, tagCodeList: {}, tagKDYCode: {}, KDYComorbidities: [], cfy_comordities:[] };
            return {
                ...state,
                registerFormValues: registerFormValues,
            };
        case CHECK_CONDITION_CODE:
            console.log('CHECK_CONDITION_CODE', action.payload.length)
            return {
                ...state,
                isConditionHasCode: action.payload.length ? true : false,
            };
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        case SET_PAGE_TITLE:
            console.log('SET_PAGE_TITLE', action.payload)
            return {
                ...state,
                page_title: action.payload,
            };
        case SET_NEW_USER:
            return {
                ...state,
                is_new_user: action.payload,
            };
        case SET_MASTER_USER_ID:
            return {
                ...state,
                master_user_id: action.payload,
            }
        case SET_ALL_USER_LIST:
            return {
                ...state,
                set_all_user_list: [...state.set_all_user_list, action.payload]
            }
        case SET_SIGN_UP_USER_LIST:
            return {
                ...state,
                set_signup_user_list: [...state.set_signup_user_list, action.payload]
            }
        case USER_IP_BASED_COUNTRY_DETAILS:
            return {
                ...state,
                user_ip_based_country_details: action.payload
            }
        case GET_PAGE_DATA:
            return {
                ...state,
                page_data: action.payload
            };
        default:
            return state;
    }
};
